// src/components/ProtectedRoute.js
import React, { useContext } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const ProtectedRoute = ({ roles, children }) => {
    const { user } = useContext(AuthContext);
    const location = useLocation(); // ✅ Get current location

    if (!user) {
        // ✅ Pass the current location in state so Login can redirect back
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (roles && !roles.some(role => user.roles.includes(role))) {
        return <Navigate to="/" />;
    }

    return children ? children : <Outlet />;
};

export default ProtectedRoute;